import React, { useState } from 'react'
import { Box, Button, Typography } from '@mui/material'
import { MAX_PIN_LENGTH } from '@/shared/constants'
import { useTranslation } from 'react-i18next'
import InputErrorPopUp from '@/pages/loginScreen/InputErrorPopUp'
import { RoundedInputField } from '@/shared/ui/RoundedInputField'
import useKeyDown from '@/shared/hooks/useKeyDown'

interface Props {
    onCheckPin: () => void
    onChangePin: (value: string) => void
    onCancelPin: () => void
    isPinError: boolean
}

const PinInputField: React.FC<Props> = ({
    onChangePin,
    onCheckPin,
    onCancelPin,
    isPinError,
}) => {
    const [pin, setPin] = useState('')
    const isEnterPinDisabled = pin.length !== MAX_PIN_LENGTH
    const { t: translate } = useTranslation()

    const editContainer = {
        position: 'relative',
        padding: '0 8px',
    }
    const handleProfileStyle = {
        marginTop: '12px',
        width: '100%',
        height: '36px',
        padding: '8px 12px',
        gap: '8px',
        borderRadius: '10px',
        bgcolor: 'primary.main',
    }
    const cancelButtonStyle = {
        marginTop: '12px',
        width: '100%',
        height: '36px',
        padding: '8px 12px',
        gap: '8px',
        borderRadius: '10px',
        bgcolor: 'transparent',
        border: '1px solid white',
        color: 'white',
    }
    const enterPinStyleStyle = {
        ...handleProfileStyle,
        bgcolor: isEnterPinDisabled ? 'custom.lightGray' : 'primary.main',
    }

    const handleInputSetValue = (value: string) => {
        if (value.length <= MAX_PIN_LENGTH && /^\d*$/.test(value)) {
            setPin(value)
            onChangePin(value)
        }
    }
    const inputFieldStyle = {
        background: 'none',
        width: '100%',
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid grey',
        color: 'white',
        marginTop: '5px',
        outline: 'none',
    }
    useKeyDown(onCheckPin)

    return (
        <Box sx={editContainer} data-testid="profileScreen">
            <Typography variant="label3" mb="8px" color="white">
                {translate('pinRequired')}
            </Typography>

            <RoundedInputField
                searchValue={pin}
                setSearchValue={handleInputSetValue}
                placeholder="PIN"
                native={{
                    autoComplete: 'new-password',
                    type: 'password',
                    name: 'pin',
                }}
                sx={inputFieldStyle}
            />

            {isPinError && (
                <InputErrorPopUp
                    styles={{
                        position: 'absolute',
                        top: '78px',
                        left: '15px',
                        width: 'max-content',
                    }}
                    errorMessage={translate('invalidPin')}
                />
            )}
            {/*todo uncomment below disabled={isEnterPinDisabled} */}
            <Box display="flex" columnGap="16px" mt="16px">
                <Button
                    data-testid="accept-button"
                    // disabled={isEnterPinDisabled}
                    sx={enterPinStyleStyle}
                    onClick={onCheckPin}>
                    <Typography color="black" variant="label4">
                        {translate('accept')}
                    </Typography>
                </Button>
                <Button
                    data-testid="cancel-button"
                    variant="outlined"
                    sx={cancelButtonStyle}
                    onClick={onCancelPin}>
                    <Typography color="white" variant="label4">
                        {translate('globalCancel')}
                    </Typography>
                </Button>
            </Box>
        </Box>
    )
}

export default PinInputField
